import React from 'react';
import { CTAButton } from './CTAButton';
const reliefs = ['No necesitás preparar cada ficha desde cero.', 'No necesitás buscar una actividad distinta para cada tema.', 'No necesitás armar todo el recorrido por separado.'];
export function MidPageCTA() {
  return <section className="py-10 px-4 bg-gray-50 text-center" data-id="element-110" data-mp="20mjqi5tlkkc3">
      <div className="max-w-3xl mx-auto" data-id="element-111" data-mp="25hz2stbyi86e">
        <h2 className="text-[20px] md:text-2xl font-black text-[#14356B] leading-tight mb-4" data-id="element-112" data-mp="25l4r46crh612">
          MENOS TIEMPO BUSCANDO ACTIVIDADES.
          <br data-id="element-113" data-mp="1ctux47tdxv3p" />
          <span className="text-[#157C8B]" data-id="element-114" data-mp="1cveczxb4q44y">
            MÁS TIEMPO ACOMPAÑANDO A TUS ALUMNOS.
          </span>
        </h2>

        <div className="space-y-1.5 mb-4" data-id="element-115" data-mp="1hsekmcnmney6">
          {reliefs.map(item => <p key={item} className="text-base text-gray-700" data-id="element-116" data-mp="1mtu1rtmop1ba">
              {item}
            </p>)}
        </div>

        <p className="text-base font-bold text-gray-800 mb-2" data-id="element-117" data-mp="2t8cwspe3qh3m">
          Ya tenés una base completa para adaptar a tu grupo y a tu forma de
          enseñar.
        </p>
        <p className="text-base font-black text-[#14356B] mb-6" data-id="element-118" data-mp="ogd0t80ocyi0">
          Descargás → elegís el tema → imprimís → trabajás.
        </p>

        <CTAButton href="#compra" data-id="element-119" data-mp="kf9lqnqgb6hu">QUIERO CATEQUESIS LISTAS</CTAButton>
      </div>
    </section>;
}